<template>
    <div>
        <div class="form-group">
            <label>Customer ID</label>
            <input type="text" class="form-control" v-model="data.customerId">
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: [
        'data'
    ],
    data() {
        return {
        };
    }
}
</script>